import {
	CUSTOM_INTEGRATION_URL,
	CUSTOM_INTEGRATION_JSON_URL,
} from 'utils/AllURLs'

export default (id, type) =>
	type === 'json'
		? `
// if node version is less than v17,
// make sure to run 'npm install node-fetch' or 'yarn install node-fetch'

import fetch from 'node-fetch' // This is for using fetch in node for versions less than v17.
// If you desire to use it in vanilla js, you do not need this import statement.

var raw = JSON.stringify({
  "first_name": "Tolleen",
  "last_name": "Integration",
  "phone": "6095554466",
  "ABrandNewAttributeNeverBeforeSeen": "Yes",
  "color": "orange",
  "favorite_dinner": "The Bacon Double Cheeseburger",
  "where_are_you": "at a store",
  "favorite_letter": "G"
});

var requestOptions = {
  method: 'POST',
  headers: {"Content-Type": "application/json"},
  body: raw,
  redirect: 'follow'
};

fetch("${CUSTOM_INTEGRATION_JSON_URL}/${id}", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.log('error', error));
`
		: `
// if node version is less than v17,
// make sure to run 'npm install node-fetch' or 'yarn install node-fetch'

import fetch from 'node-fetch' // This is for using fetch in node for versions less than v17.
// If you desire to use it in vanilla js, you do not need this import statement.

var urlencoded = new URLSearchParams();
urlencoded.append("first_name", "Tolleen");
urlencoded.append("last_name", "Integration");
urlencoded.append("phone", "6095554466");
urlencoded.append("ABrandNewAttributeNeverBeforeSeen", "Yes");
urlencoded.append("color", "orange");
urlencoded.append("favorite_dinner", "The Bacon Double Cheeseburger");
urlencoded.append("where_are_you", "at a store");
urlencoded.append("favorite_letter", "G");

var requestOptions = {
  method: 'POST',
  headers: {"Content-Type": "application/x-www-form-urlencoded"},
  body: urlencoded,
  redirect: 'follow'
};

fetch("${CUSTOM_INTEGRATION_URL}/${id}", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.log('error', error));
`
